import React from "react";
import classNames from "classnames";


interface HighlightTextProps {
    query: string;
    keyword?: string;
    className?: string;
    highlightClassName: string;
}

const HighlightText: React.FC<HighlightTextProps> = (props) => {
    const { query, keyword, className: propsClassName, highlightClassName } = props;

    if (!keyword) {
        return (
            <span className={classNames("highlight-text-span", propsClassName)}>
                {query}
            </span>
        );
    }

    const regex = new RegExp(`(${escapeRegExp(keyword)})`, "gi");
    const parts = query.split(regex);

    return (
        <span className={classNames("highlight-text-span", propsClassName)}>
          {parts.map((part, index) => (
            <span key={index}
                  className={classNames(regex.test(part) ? highlightClassName : "")}
            >
                {part}
            </span>
          ))}
        </span>
    );
};

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default HighlightText;
